import React from 'react';
import { ABOUT_TIMELINE } from '../data/copy';

export const Timeline = () => (
    <ol className="border-l border-brand-hairline pl-8" data-testid="about-timeline">
        {ABOUT_TIMELINE.map((m) => (
            <li key={m.year} className="relative mb-10 last:mb-0">
                <span
                    aria-hidden="true"
                    className="absolute -left-[33px] top-2 h-2 w-2 bg-brand-gold"
                />
                <div className="font-display text-xs font-bold uppercase tracking-[0.2em] text-brand-gold">
                    {m.year}
                </div>
                <p className="mt-2 font-sans text-base text-brand-muted leading-relaxed">
                    {m.text}
                </p>
            </li>
        ))}
    </ol>
);

export default Timeline;
